import { NavLink, Link } from "react-router";
import { useCart } from "../../lib/cart.tsx";

const nav = [
  { to: "/collection", label: "The Collection" },
  { to: "/create", label: "Create Your Candle" },
  { to: "/craft", label: "Our Craft" },
  { to: "/contact", label: "Contact" },
];

export default function SiteHeader() {
  const { itemCount, open } = useCart();

  return (
    <header className="sticky top-0 z-30 border-b border-[var(--color-rule)]/60 bg-[var(--color-cream)]/80 backdrop-blur-md">
      <div className="bg-[var(--color-emerald-deep)] py-2 text-center">
        <p className="text-[0.65rem] font-light uppercase tracking-[0.18em] text-[var(--color-sage-light)]">
          Hand-Poured · 100% Vegan · Crafted to Evoke Your Memories
        </p>
      </div>
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-6 py-6 md:px-10 md:py-7">
        <Link to="/" className="group flex flex-col leading-none">
          <span className="font-serif text-2xl font-semibold tracking-[0.18em] text-[var(--color-emerald-deep)] transition-colors duration-500 group-hover:text-[var(--color-emerald)] md:text-[1.6rem]">
            BEADORÉ
          </span>
          <span className="mt-1 text-[0.6rem] font-light uppercase tracking-[0.18em] text-[var(--color-amber)]">
            Illuminate Your Moments
          </span>
        </Link>
        <nav className="hidden items-center gap-10 md:flex">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                [
                  "group relative text-[0.78rem] uppercase tracking-[0.16em] transition-colors duration-300",
                  isActive
                    ? "text-[var(--color-emerald-deep)]"
                    : "text-[var(--color-stone)] hover:text-[var(--color-emerald)]",
                ].join(" ")
              }
            >
              {({ isActive }) => (
                <>
                  {item.label}
                  <span
                    className={[
                      "pointer-events-none absolute -bottom-1 left-0 right-0 h-px origin-center bg-gradient-to-r from-transparent via-[var(--color-amber)] to-transparent transition-transform duration-500",
                      isActive
                        ? "scale-x-100"
                        : "scale-x-0 group-hover:scale-x-100",
                    ].join(" ")}
                  />
                </>
              )}
            </NavLink>
          ))}
        </nav>
        <button
          type="button"
          onClick={open}
          aria-label={`Open cart${itemCount > 0 ? ` (${itemCount} items)` : ""}`}
          className="relative flex h-10 w-10 items-center justify-center text-[var(--color-emerald-deep)] transition-colors hover:text-[var(--color-emerald)]"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden
          >
            <path
              d="M6 8h12l-1 11a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L6 8Z"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 8V6a3 3 0 0 1 6 0v2"
              stroke="currentColor"
              strokeWidth="1.4"
              strokeLinecap="round"
            />
          </svg>
          {itemCount > 0 ? (
            <span
              aria-hidden
              className="absolute -top-0.5 -right-0.5 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[var(--color-amber)] px-1 text-[0.6rem] font-semibold text-[var(--color-warm-white)]"
            >
              {itemCount}
            </span>
          ) : null}
        </button>
      </div>
    </header>
  );
}
